import "./header.scss";

import React, { useState, useEffect } from "react";
import { Link } from "gatsby";
import classNames from "classnames";
import SocialMenu from "components/SocialMenu";
import AccessibilityMenu from "components/AccessibilityMenu";
import InfoPopup from "components/InfoPopup";

const Header = () => {
   const [mobileMenu, setMobileMenu] = useState(false);
   const [selectedMenu, setSelectedMenu] = useState("");
   const [isScrolled, setIsScrolled] = useState(false);

   // Popup State
   const [popup, setPopup] = useState("");

   const popupControls = {
      popup,
      setPopup,
   };

   useEffect(() => {
      window.addEventListener("scroll", () => {
         setIsScrolled(window.scrollY > 10);
      });
   }, []);

   const menuItems = [
      {
         label: "Aktualności",
         url: "/aktualnosci",
      },
      {
         label: "O Małopolska Lokalnie",
         key: "about",
         submenu: [
            {
               label: "O Małopolska Lokalnie",
               url: "/o-malopolska-lokalnie",
            },
            {
               label: "Program w skrócie",
               url: "/program-w-skrocie",
            },
            {
               label: "Terminy konkursów",
               url: "/terminy-konkursow",
            },
            {
               label: "Trwające konkursy",
               url: "/trwajace-konkursy",
            },
            // {
            //    label: "Konkursy zakończone",
            //    url: "/konkursy-zakonczone",
            // },
            {
               label: "Operatorzy",
               url: "/operatorzy-malopolska-lokalnie",
            },
            {
               label: "Ambasadorowie",
               url: "/ambasadorowie-fio-malopolska-lokalnie",
            },
         ],
      },
      {
         label: "Lokalne programy grantowe",
         key: "local",
         submenu: [
            {
               label: "Konkursy realizowane",
               url: "/konkursy-realizowane",
            },
            // {
            //    label: "Konkursy zakończone",
            //    url: "/konkursy-zakonczone",
            // },
            {
               label: "Oferta",
               url: "/oferta",
            },
         ],
      },
      {
         label: "Dla wnioskodawców",
         key: "applicants",
         submenu: [
            {
               label: "Dla kogo",
               url: "/dla-kogo",
            },
            {
               label: "Rodzaje wspieranych działań",
               url: "/rodzaje-wspieranych-dzialan",
            },
            {
               label: "Jak złożyć wniosek",
               url: "/jak-zlozyc-wniosek",
            },
            {
               label: "Dokumentacja projektowa",
               url: "/dokumentacja-projektowa",
            },
            {
               label: "Szkolenia i webinary",
               url: "/szkolenia-i-webinary",
            },
            {
               label: "Kontakt do doradców",
               url: "/kontakt-do-doradcow",
            },
         ],
      },
      {
         label: "Dla realizatorów",
         key: "producers",
         submenu: [
            {
               label: "Podręcznik dla realizatorów",
               url: "/podrecznik-dla-realizatorow",
            },
            {
               label: "Materiały graficzne",
               url: "/materialy-graficzne",
            },
            {
               label: "Szkolenia i webinary",
               url: "/szkolenia-i-webinary",
            },
            {
               label: "Kontakt do doradców",
               url: "/kontakt-do-doradcow",
            },
         ],
      },
      {
         label: "Inspiracje",
         key: "inspirations",
         submenu: [
            {
               label: "Inspiracje",
               url: "/inspiracje",
            },
            {
               label: "Archiwum",
               external: true,
               url: "http://archiwum.malopolskalokalnie.pl/index.php/plebiscyt/archiwalne.html",
               icon: "external-link.svg",
            },
         ],
      },
      {
         label: "Głosowanie w konkursie internetowym",
         key: "voting",
         submenu: [
            {
               label: "Mapa realizowanych inicjatyw",
               url: "/mapa-realizowanych-inicjatyw",
            },
            {
               label: "Głosowanie",
               url: "/glosowanie",
            },
            {
               label: "Wyniki głosowania",
               url: "/glosowanie/wyniki-glosowania",
            },
         ],
      },
      {
         label: "Kontakt",
         key: "contact",
         submenu: [
            {
               label: "Operatorzy",
               url: "/operatorzy-malopolska-lokalnie",
            },
            {
               label: "Ambasadorowie",
               url: "/ambasadorowie-fio-malopolska-lokalnie",
            },
         ],
      },
   ];

   return (
      <header>
         <div
            className={classNames(`header`, {
               [`header--scrolled`]: isScrolled,
            })}
         >
            <div className="container header__container">
               <a href="/" className="header__logo-link">
                  <img
                     src={require("../../assets/images/logo.svg").default}
                     alt="Małopolska Lokalnie"
                     className="header__logo img-fluid"
                  />
               </a>
               <div className="header__social-wrapper">
                  <ul className="header__social-list">
                     <li className="header__social-item header__social-item--facebook">
                        <img
                           src={
                              require("../../assets/icons/facebook.svg").default
                           }
                           alt="Facebook Logo"
                           className="header__social-icon"
                        />
                        <span className="header__social-menu-wrapper" />
                        <div className="header__social-menu">
                           <SocialMenu />
                        </div>
                     </li>
                     <li className="header__social-item header__social-item--youtube">
                        <a
                           href="https://www.youtube.com/channel/UCnDIUE-TxRv7LhbJYJ5wYSg"
                           target="_blank"
                           rel="noopener nofollow noreferrer"
                        >
                           <img
                              src={
                                 require("../../assets/icons/youtube.svg")
                                    .default
                              }
                              alt="Youtube Logo"
                              className="header__social-icon"
                           />
                        </a>
                     </li>
                     <li className="header__social-item header__social-item--instagram">
                        <a
                           href="https://www.instagram.com/malopolskalokalnie.pl/"
                           target="_blank"
                           rel="noopener nofollow noreferrer"
                        >
                           <img
                              src={
                                 require("../../assets/icons/instagram.svg")
                                    .default
                              }
                              alt="Instagram Logo"
                              className="header__social-icon"
                           />
                        </a>
                     </li>
                     <li className="header__social-item header__social-item--accessibility">
                        <img
                           src={
                              require("../../assets/icons/accessibility.svg")
                                 .default
                           }
                           alt="Opcje dostępności"
                           className="header__social-icon"
                        />
                        <span className="header__accessibility-menu-wrapper" />
                        <div className="header__accessibility-menu">
                           <AccessibilityMenu {...popupControls} />
                        </div>
                     </li>
                  </ul>
                  <div
                     className={
                        mobileMenu
                           ? "header__burger-button header__burger-button--opened"
                           : "header__burger-button"
                     }
                     aria-hidden="true"
                     onClick={(e) => {
                        setMobileMenu(!mobileMenu);
                        setSelectedMenu("");
                     }}
                  >
                     <span />
                  </div>
               </div>
            </div>
            <div className="container header__container header__container--items">
               <ul className="header__link-list">
                  {menuItems.map((item, index) => {
                     return item.url ? (
                        <li className="header__link-list-item" key={index}>
                           <Link to={item.url}>{item.label}</Link>
                        </li>
                     ) : (
                        <li
                           className={
                              item.key === "contact"
                                 ? "header__link-list-item header__link-list-item--has-submenu header__link-list-item--contact"
                                 : "header__link-list-item header__link-list-item--has-submenu"
                           }
                           key={index}
                        >
                           <span>{item.label}</span>
                           <ul className="header__link-sublist">
                              {item.submenu.map((item, index) => {
                                 return (
                                    <li
                                       className="header__link-sublist-item"
                                       key={index}
                                    >
                                       {item.external !== true ? (
                                          <Link to={item.url}>
                                             {item.label}
                                          </Link>
                                       ) : (
                                          <a href={item.url}>
                                             {item.label}
                                             {item.icon && (
                                                <img
                                                   src={
                                                      require(`../../assets/icons/${item.icon}`)
                                                         .default
                                                   }
                                                   alt={item.label}
                                                   className="header__link-sublist-icon"
                                                />
                                             )}
                                          </a>
                                       )}
                                    </li>
                                 );
                              })}
                           </ul>
                        </li>
                     );
                  })}
               </ul>
            </div>
         </div>
         <div>
            {/* Popups */}
            {popup === "bigFont" && (
               <InfoPopup dismiss={(e) => setPopup("")}>
                  Czcionka nie może być już większa.
               </InfoPopup>
            )}
            {popup === "smallFont" && (
               <InfoPopup dismiss={(e) => setPopup("")}>
                  Czcionka nie może być już mniejsza.
               </InfoPopup>
            )}
            {popup === "lowContrast" && (
               <InfoPopup dismiss={(e) => setPopup("")}>
                  Kontrast już jest niski.
               </InfoPopup>
            )}
            {popup === "highContrast" && (
               <InfoPopup dismiss={(e) => setPopup("")}>
                  Kontrast już jest wysoki.
               </InfoPopup>
            )}
         </div>
         <div
            className={
               mobileMenu ? "mobile-menu mobile-menu--opened" : "mobile-menu"
            }
         >
            <button
               // className={
               // 	selectedMenu === ""
               // 		? "mobile-menu__submenu-back mobile-menu__submenu-back--hidden"
               // 		: "mobile-menu__submenu-back"
               // }
               className={classNames(`mobile-menu__submenu-back`, {
                  [`mobile-menu__item--scrolled`]: isScrolled,
                  [`mobile-menu__submenu-back--hidden`]: selectedMenu === "",
               })}
               onClick={(e) => setSelectedMenu("")}
               type="button"
            >
               Powrót
            </button>
            {menuItems.map((item, index) => {
               return item.url ? (
                  <div className="mobile-menu__item" key={index}>
                     <Link to={item.url}>{item.label}</Link>
                  </div>
               ) : (
                  <div
                     key={index}
                     className="mobile-menu__item mobile-menu__item--submenu"
                     onClick={(e) => {
                        setSelectedMenu(item.key);
                     }}
                     aria-hidden="true"
                  >
                     {item.label}
                     <div
                        className={
                           selectedMenu === item.key
                              ? "mobile-menu__submenu mobile-menu__submenu--active"
                              : "mobile-menu__submenu"
                        }
                     >
                        {item.submenu.map((item, index) => {
                           return (
                              <div
                                 className="mobile-menu__submenu-item"
                                 key={index}
                              >
                                 <Link to={item.url}>{item.label}</Link>
                              </div>
                           );
                        })}
                     </div>
                  </div>
               );
            })}
            {/* Accessibility Button */}
            <div
               className={
                  isScrolled
                     ? "mobile-menu__item mobile-menu__item--submenu mobile-menu__item--accessibility mobile-menu__item--scrolled"
                     : "mobile-menu__item mobile-menu__item--submenu mobile-menu__item--accessibility"
               }
               onClick={(e) => {
                  setSelectedMenu("accessibility");
               }}
               aria-hidden="true"
            />
            {/* Accessibility Menu */}
            <div
               className={
                  selectedMenu === "accessibility"
                     ? "mobile-menu__submenu mobile-menu__submenu--active"
                     : "mobile-menu__submenu"
               }
            >
               <div className="mobile-menu__submenu-item mobile-menu__submenu-item--accessibility">
                  <AccessibilityMenu {...popupControls} />
               </div>
            </div>
         </div>
         <div className="header__spacer" />
      </header>
   );
};

export default Header;
